import { storageKeys } from '../../../utils/browser-storage/storage-keys';
import detectBrowser from '../../../utils/detect-browser';
import detectDevice from '../../../utils/detect-device';
import qualityEventsHelpers, { getUserAgentForQE } from '../quality-events.helpers';

export const HEADER_EVENTS = {
    allocatedCreditsCampaignPopup() {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                user_id: window.storage.getItem(storageKeys.user.userId)
            }),
            page_url: window.location.href,
            type: 'allocatedCreditsCampaign:popupShown',
            user_agent: getUserAgentForQE(),
            user_device: detectDevice()
        });
    },
    clickAiToolsIcon() {
        qualityEventsHelpers.track({
            type: 'clickAiToolsIcon'
        });
    }
};
